import { useSessionAppointmentId } from '@hooks/useSessionAppointmentId';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getMetaAppointmentsQuery } from 'vl-common/src/schemas/getMetaAppointments';

const useAppointmentMeta = () => {
  const appt_id = useSessionAppointmentId();

  return useSuspenseQuery(getMetaAppointmentsQuery({ appt_id }));
};

export default useAppointmentMeta;
